// extracted by mini-css-extract-plugin
export default {"backdrop":"MainBackdrop_backdrop__XFutk"};